import { lazyGetDeleteSections } from "owa-mail-ribbon-sections/lib/sections";

import type { ReadOnlyRibbonControlDefProps } from "owa-mail-ribbon-utils";
import { setMenuDefinition } from "../../mutatorActions/setMenuDefinition";
import type { MailRibbonTabId } from "owa-ribbon-ids/lib/mailRibbonId";

export const onDeleteMenuClicked = (props: ReadOnlyRibbonControlDefProps, keytipTabId: MailRibbonTabId): void => {
    lazyGetDeleteSections.import().then(getDeleteSections => {
        setMenuDefinition("DeleteMenuDefinitionStore", props.projectionTabId /* projectionTabId */, () => {
            return {
                sections: getDeleteSections(props, keytipTabId),
            };
        });
    });
};
